import {Component} from 'react';
import {Label} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {DragHandle, Indenter} from './DragHandle';


class SectionSelector extends Component {
  static propTypes = {
    content: PropTypes.node.isRequired,
    backgroundImage: PropTypes.string,
    style: PropTypes.object,
    hasDragHandle: PropTypes.bool,
    actionMenu: PropTypes.node,
  };

  static defaultProps = {
    hasDragHandle: false,
  };

  render() {
    const {actionMenu, content, hasDragHandle, backgroundImage} = this.props;

    const backgroundImageStyles = backgroundImage ? {
      backgroundImage: `url(${backgroundImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'calc(100% - 1rem) center'
    } : {};

    return (
      <Label className="reportSection" style={backgroundImageStyles}>
        {hasDragHandle ? <DragHandle/> : <Indenter content="&nbsp;"/>}
        <span className="title" onMouseLeave={this.hideMenu}>
          {content}
          {actionMenu}
        </span>
      </Label>
    );
  }
}

export default SectionSelector;